import { DeleteTerminalModel } from "../../app/data/terminal-details/models";

export interface DeleteTerminalState {
    data: DeleteTerminalModel | null;  
    isLoading: boolean;
    isSuccess: boolean;
    isError: boolean;
    errorMessage?: string | null;
}

export const initialDeleteTerminalState: DeleteTerminalState = {
    data: null,
    isLoading: false,
    isSuccess: false,
    isError: false,
    errorMessage: null
};
  